import axios from 'axios'
import store from '../store'

// Axios instance oluşturuyoruz
const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_URL
})

// Request interceptor - tüm isteklere token ekliyoruz
axiosInstance.interceptors.request.use(
    (config) => {
        const token = store.state.user?.token
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

export default axiosInstance 